import { useMutation } from "@tanstack/react-query";
import { deleteApiPracticesPracticeIdPatientsPatientIdCard } from "@/lib/api-client/endpoints/patient/patient";
import { useUpdatePatientCardCache } from "./useUpdatePatientCardCache";
import { AnalyticsEvent, trackEvent } from "@/lib/analytics";

interface Props {
  onSuccess?: VoidFunction;
  patientId: string;
  practiceId: string;
}

const useDeletePatientCard = ({ onSuccess, patientId, practiceId }: Props) => {
  const updatePatientCardCache = useUpdatePatientCardCache(patientId);

  const mutation = useMutation({
    mutationFn: async () => {
      trackEvent(AnalyticsEvent.DeleteCard, {
        patient_id: patientId,
      });
      await deleteApiPracticesPracticeIdPatientsPatientIdCard(
        practiceId,
        patientId,
      );
    },
    onSuccess: () => {
      onSuccess?.();
      updatePatientCardCache({
        cardOnFile: undefined,
      });
    },
  });

  return {
    deleteCard: mutation.mutate,
    isDeletingCard: mutation.isPending,
  };
};

export default useDeletePatientCard;
